<!-- <div class="announcements" *ngIf="activeAnnouncement">
  <p id="announcement">
    {{activeAnnouncement}}
  </p>
</div>
<br/> -->
<div class="wallboard">
    <div class="select-container">
      <select class="uk-select site-select" (change)="updateActiveSite($event.target.value)" *ngIf="!wallboardService.activeSiteNameLife.length">
        <option value="">Select Site</option>
        <option *ngFor="let site of wallboardService.siteListLife">
          {{ site }}
        </option>
      </select>
    </div>
    <div *ngIf="showWallboard">
        <!-- <div id="logo" (click)="router.navigate(['/'+ configService.activeLOB])"> -->
          <!-- <img _ngcontent-c1="" class="lightmodeImage" id="kemperLogo" src="./assets/logo.png"> -->
          <!-- <img class="darkmodeImage" src="./assets/logo-dark.png"> -->
        <!-- </div> -->
        <!-- <div id="title">
          <h1 class="doubleheader announcements" *ngIf="mainTitle && showWallboard && secondEnabled">{{ mainTitle }}</h1>
        </div> -->
        <div id="title">
          <h1 class="doubleheader announcements" *ngIf="combinedMetrics.title && showWallboard && secondEnabled">{{ combinedMetrics.title }}</h1>
        </div>
        
        <div id="time">
            <h2>{{ time | date: 'hh:mm:ss' }}</h2>
        </div>
    </div>
    <div [class]="'metric-panes ' + (secondEnabled ? 'double' : '')" *ngIf="showWallboard">
      <app-metrics
        [title]="siteMetrics[queueDisplayIteration].QueueName"
        [thresholds]="wallboardService.activeQueueConfigLife.Thresholds"
        [metrics]="siteMetrics[queueDisplayIteration].metrics"
        *ngIf="!secondEnabled"
      >
      </app-metrics>
      <app-metrics
        [title]="combinedMetrics.title"
        [thresholds]="combinedThresholds"
        [metrics]="combinedMetrics.metrics"
        *ngIf="secondEnabled"
      >
      </app-metrics>
    </div>

</div>

<!-- <div class="announcements">
  <p id="announcement">
    {{activeAnnouncement}}
  </p>
</div> -->
  